/**
 * İkon dəsti — tək mənbə.
 *
 * NİYƏ EMOJİ DEYİL
 *
 * Əvvəl bütün ikonlar emoji idi: ✉ 📅 👥 📥 🏢 💳 ⚙ 📎 🗑️ ⚠️. Bu, məhsulun
 * bitməmiş görünməsinin ƏN GÜCLÜ tək siqnalıdır və səbəbi estetik deyil,
 * texnikidir:
 *
 *   • Emoji hər əməliyyat sistemində FƏRQLİ rəsmdir — eyni panel Windows,
 *     macOS və Android-də üç cür görünür.
 *   • Emoji rəngli şriftdir: `color` təsir etmir, ona görə aktiv/passiv
 *     vəziyyəti göstərmək mümkün deyil və qaranlıq rejimdə uyğunlaşmır.
 *   • Optik baseline mətndən fərqlidir — sətirdə həmişə bir az sürüşmüş
 *     görünür və heç bir CSS bunu tam düzəltmir.
 *   • Ölçü `font-size`-dan asılıdır, `stroke-width` yoxdur — qalınlıq
 *     mətnin qalınlığı ilə uyğunlaşmır.
 *
 * BU DƏSTİN QAYDALARI
 *   • 24×24 viewBox, 1.5px xətt, yuvarlaq uc və birləşmə
 *   • `fill: none`, `stroke: currentColor` — rəngi mətndən miras alır,
 *     yəni aktiv/passiv/qaranlıq rejim avtomatik işləyir
 *   • Yalnız `star` doludur (`fill`) — o, VƏZİYYƏT göstəricisidir, ona görə
 *     dolu/boş fərqi uzaqdan görünməlidir
 */

export type IconName =
  | 'inbox'
  | 'send'
  | 'draft'
  | 'archive'
  | 'spam'
  | 'trash'
  | 'folder'
  | 'paperclip'
  | 'star'
  | 'star-filled'
  | 'reply'
  | 'reply-all'
  | 'forward'
  | 'refresh'
  | 'back'
  | 'close'
  | 'search'
  | 'settings'
  | 'building'
  | 'calendar'
  | 'contacts'
  | 'billing'
  | 'import'
  | 'menu'
  | 'download'
  | 'eye'
  | 'eye-off';

/**
 * Yol məlumatları.
 *
 * ⚠️ Hamısı 24×24 sistemində və eyni optik ağırlıqda çəkilib. Yeni ikon
 * əlavə edəndə başqa dəstdən kopyalamaq olmaz — fərqli xətt qalınlığı və
 * fərqli künc radiusu dərhal gözə dəyir.
 */
const PATHS: Record<IconName, React.ReactNode> = {
  inbox: (
    <>
      <path d="M3 12h4l2 3h6l2-3h4" />
      <path d="M5 5h14l2 7v5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-5z" />
    </>
  ),
  send: <path d="M4 12l16-8-6 16-2.5-6.5L4 12z" />,
  draft: (
    <>
      <path d="M5 4h9l5 5v11a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1z" />
      <path d="M14 4v5h5" />
    </>
  ),
  archive: (
    <>
      <rect x="3" y="4" width="18" height="4" rx="1" />
      <path d="M5 8v11a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8" />
      <path d="M10 12h4" />
    </>
  ),
  spam: (
    <>
      <path d="M12 3l8 3v6c0 4.5-3.2 8.2-8 9-4.8-.8-8-4.5-8-9V6l8-3z" />
      <path d="M12 8v4" />
      <path d="M12 15.5v.5" />
    </>
  ),
  trash: (
    <>
      <path d="M4 7h16" />
      <path d="M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
      <path d="M6 7l1 13a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1l1-13" />
      <path d="M10 11v6M14 11v6" />
    </>
  ),
  folder: <path d="M3 7a1 1 0 0 1 1-1h5l2 2h8a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z" />,
  paperclip: (
    <path d="M20 10.5l-8.2 8.2a4.5 4.5 0 0 1-6.4-6.4l8.5-8.5a3 3 0 0 1 4.3 4.3l-8.5 8.5a1.5 1.5 0 0 1-2.1-2.1l7.8-7.8" />
  ),
  star: <path d="M12 3.5l2.6 5.4 5.9.8-4.3 4.1 1 5.9-5.2-2.8-5.2 2.8 1-5.9L3.5 9.7l5.9-.8z" />,
  'star-filled': (
    <path
      d="M12 3.5l2.6 5.4 5.9.8-4.3 4.1 1 5.9-5.2-2.8-5.2 2.8 1-5.9L3.5 9.7l5.9-.8z"
      fill="currentColor"
    />
  ),
  reply: (
    <>
      <path d="M9 8L4 12l5 4" />
      <path d="M4 12h9a7 7 0 0 1 7 7v1" />
    </>
  ),
  'reply-all': (
    <>
      <path d="M8 8l-4 4 4 4" />
      <path d="M13 8l-4 4 4 4" />
      <path d="M9 12h6a6 6 0 0 1 6 6v1" />
    </>
  ),
  forward: (
    <>
      <path d="M15 8l5 4-5 4" />
      <path d="M20 12h-9a7 7 0 0 0-7 7v1" />
    </>
  ),
  refresh: (
    <>
      <path d="M20 11a8 8 0 1 0-1.5 5.5" />
      <path d="M20 5v6h-6" />
    </>
  ),
  back: <path d="M15 5l-7 7 7 7" />,
  close: <path d="M6 6l12 12M18 6L6 18" />,
  search: (
    <>
      <circle cx="11" cy="11" r="6" />
      <path d="M20 20l-4.5-4.5" />
    </>
  ),
  settings: (
    <>
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 14a1.6 1.6 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.6 1.6 0 0 0-1.8-.3 1.6 1.6 0 0 0-1 1.5V20a2 2 0 1 1-4 0v-.1A1.6 1.6 0 0 0 9 18.4a1.6 1.6 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.6 1.6 0 0 0 .3-1.8 1.6 1.6 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1A1.6 1.6 0 0 0 4.6 9a1.6 1.6 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.6 1.6 0 0 0 1.8.3H9a1.6 1.6 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.6 1.6 0 0 0 1 1.5 1.6 1.6 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.6 1.6 0 0 0-.3 1.8V9a1.6 1.6 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.6 1.6 0 0 0-1.5 1z" />
    </>
  ),
  building: (
    <>
      <path d="M4 21V6a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v15" />
      <path d="M14 10h5a1 1 0 0 1 1 1v10" />
      <path d="M7 9h4M7 13h4M7 17h4M17 14h1M17 18h1" />
      <path d="M2 21h20" />
    </>
  ),
  calendar: (
    <>
      <rect x="3" y="5" width="18" height="16" rx="2" />
      <path d="M3 10h18M8 3v4M16 3v4" />
    </>
  ),
  contacts: (
    <>
      <circle cx="9" cy="9" r="3" />
      <path d="M3 20a6 6 0 0 1 12 0" />
      <path d="M16 4a3 3 0 0 1 0 6" />
      <path d="M18 20a6 6 0 0 0-3-5.2" />
    </>
  ),
  billing: (
    <>
      <rect x="2" y="6" width="20" height="13" rx="2" />
      <path d="M2 10h20" />
      <path d="M6 15h3" />
    </>
  ),
  import: (
    <>
      <path d="M12 3v11" />
      <path d="M8 10l4 4 4-4" />
      <path d="M4 17v2a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-2" />
    </>
  ),
  menu: <path d="M4 7h16M4 12h16M4 17h16" />,
  // ⚠️ «Söndür/aç» üçün — SİLMƏ İLƏ QARIŞMAMALIDIR.
  // Söndürülmüş alias qalır və geri qaytarıla bilir; silinən qayıtmır.
  // İki fərqli nəticəni oxşar ikonla göstərmək istifadəçini yanlış
  // düyməyə basmağa aparır.
  eye: (
    <>
      <path d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6-10-6-10-6z" />
      <circle cx="12" cy="12" r="3" />
    </>
  ),
  'eye-off': (
    <>
      <path d="M10.6 6.2A9.9 9.9 0 0 1 12 6c6.5 0 10 6 10 6a17 17 0 0 1-3 3.6" />
      <path d="M6.6 6.7A17 17 0 0 0 2 12s3.5 6 10 6a9.7 9.7 0 0 0 4-.8" />
      <path d="M9.9 9.9a3 3 0 0 0 4.2 4.2" />
      <path d="M3 3l18 18" />
    </>
  ),
  download: (
    <>
      <path d="M12 4v10" />
      <path d="M8 10l4 4 4-4" />
      <path d="M5 19h14" />
    </>
  ),
};

interface Props {
  name: IconName;
  /** Piksel ölçüsü. Rail-də 20, sətirlərdə 18, kiçik nişanlarda 15. */
  size?: number;
  className?: string;
  /** Yalnız mətnsiz düymələrdə lazımdır — yanında yazı varsa boş qoyulur. */
  title?: string;
}

export function Icon({ name, size = 18, className, title }: Props): React.ReactElement {
  return (
    <svg
      className={className ? `icon ${className}` : 'icon'}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      // ⚠️ Yanında mətn varsa ikon ekran oxuyucusuna TƏKRAR məlumatdır —
      // `aria-hidden` onu gizlədir. Tək başına düymədədirsə `title` verilir.
      {...(title ? { role: 'img', 'aria-label': title } : { 'aria-hidden': true })}
    >
      {title ? <title>{title}</title> : null}
      {PATHS[name]}
    </svg>
  );
}
